<template>
  <div class="container mt-5 px-4">
    <!-- Main Form Card -->
    <div class="form-card">
      <div class="row g-4">
        <!-- Left Section -->
        <div class="col-lg-6">
          <div class="form-section">
            <h5 class="section-title mb-4">
              <i class="bi bi-info-circle me-2"></i>Group Information
            </h5>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-tag me-2"></i>Group Name
              </label>
              <input 
                type="text" 
                class="custom-input" 
                placeholder="Enter group name" 
                v-model="name"
              >
            </div>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-unlock me-2"></i>Plan Access
              </label>
              <div class="toggle-wrapper">
                <select class="custom-input" v-model="planall">
                  <option :value="true">All Plans Accessible</option>
                  <option :value="false">Limited Access</option>
                </select>
              </div>
              <small class="form-text">
                <i class="bi bi-info-circle-fill me-1"></i>
                {{ planall ? 'Group members can access all available plans' : 'Group members have restricted plan access' }}
              </small>
            </div>

            <!-- Feature Box -->
            <div class="feature-box">
              <div class="feature-icon">
                <i class="bi bi-shield-check"></i>
              </div>
              <div class="feature-content">
                <h6 class="mb-1">Access Control</h6>
                <p class="mb-0">Manage permissions and plan accessibility for all members in this group efficiently.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Section -->
        <div class="col-lg-6">
          <div class="form-section">
            <h5 class="section-title mb-4">
              <i class="bi bi-pencil-square me-2"></i>Additional Details
            </h5>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-chat-left-text me-2"></i>Description
              </label>
              <textarea 
                class="custom-input" 
                rows="8" 
                placeholder="Add a detailed description for this group..." 
                v-model="description"
              ></textarea>
              <small class="form-text">
                Describe the purpose and scope of this group
              </small>
            </div>

            <!-- Info Box -->
            <div class="info-box">
              <i class="bi bi-lightbulb text-warning me-2"></i>
              <div>
                <strong>Group Benefits:</strong>
                <ul class="mb-0 mt-2">
                  <li>Organize users by department or project</li>
                  <li>Manage permissions collectively</li>
                  <li>Simplify access control</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="button-row mt-5">
        <button @click="clearDataGroup()" class="btn-clear">
          <i class="bi bi-arrow-counterclockwise me-2"></i>Clear Form
        </button>
        <button 
          @click="createGroup()" 
          class="btn-create" 
          :disabled="!name"
        >
          <i class="bi bi-check-circle me-2"></i>Create Group
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      planall: false,
      description: "",
    };
  },
  methods: {
    async clearDataGroup() {
      this.name = "";
      this.planall = false;
      this.description = "";
    },
    async createGroup() {
      try {
        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/group`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            "name": this.name,
            "description": this.description,
            "planall": this.planall
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        this.$router.push('/settings/group/list');
        console.log('Group page created:', result);
      } catch (error) {
        console.error('Error creating dashboard page:', error);
      }
    }
  },
  created() {
  }
}
</script>

<style scoped>

/* Header Card */
.header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
  color: white;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  backdrop-filter: blur(10px);
}

.header-card h3 {
  color: white;
  margin: 0;
}

.header-card p {
  color: rgba(255, 255, 255, 0.9);
}

/* Form Card */
.form-card {
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.form-section {
  height: 100%;
}

.section-title {
  color: #2d3748;
  font-weight: 600;
  font-size: 1.1rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e2e8f0;
}

/* Custom Input Styles */
.custom-label {
  display: block;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.custom-input {
  width: 100%;
  padding: 0.85rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: #fafafa;
}

.custom-input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-input::placeholder {
  color: #a0aec0;
}

textarea.custom-input {
  resize: vertical;
  min-height: 120px;
}

select.custom-input {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
}

.form-text {
  display: block;
  margin-top: 0.5rem;
  color: #718096;
  font-size: 0.85rem;
}

/* Feature Box */
.feature-box {
  background: linear-gradient(135deg, #e0e7ff 0%, #ddd6fe 100%);
  padding: 1.5rem;
  border-radius: 12px;
  display: flex;
  gap: 1rem;
  align-items: start;
  border-left: 4px solid #667eea;
  margin-top: 1.5rem;
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.feature-content h6 {
  color: #2d3748;
  font-weight: 600;
  margin: 0;
}

.feature-content p {
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* Info Box */
.info-box {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  padding: 1.25rem;
  border-radius: 10px;
  display: flex;
  align-items: start;
  border-left: 4px solid #f59e0b;
  margin-top: 1rem;
}

.info-box i {
  font-size: 1.5rem;
  margin-top: 0.1rem;
  flex-shrink: 0;
}

.info-box strong {
  color: #92400e;
  display: block;
}

.info-box ul {
  padding-left: 1.25rem;
  color: #78350f;
  font-size: 0.9rem;
}

.info-box ul li {
  margin-bottom: 0.25rem;
}

/* Buttons */
.button-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 2px solid #e2e8f0;
}

.btn-clear {
  padding: 0.85rem 2rem;
  border: 2px solid #e2e8f0;
  background: white;
  color: #718096;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.btn-clear:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
  color: #2d3748;
  transform: translateY(-1px);
}

.btn-create {
  padding: 0.85rem 2.5rem;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-create:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.btn-create:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  box-shadow: none;
}

/* Responsive */
@media (max-width: 991px) {
  .form-card {
    padding: 1.5rem;
  }
  
  .header-card {
    padding: 1.5rem;
  }
  
  .button-row {
    flex-direction: column-reverse;
  }
  
  .btn-clear,
  .btn-create {
    width: 100%;
    justify-content: center;
  }

  .feature-box {
    flex-direction: column;
    text-align: center;
  }

  .feature-icon {
    margin: 0 auto;
  }
}
</style>